import {Box, Grid, Chip, Link, Typography} from "@mui/material";
import React from "react";
import {useNavigate} from "react-router-dom";
import {get8DigitDate} from "../../../utils/timeUtils";
import {Legend} from "./components/Legend";
import useIsMobile from "../../../hooks/utilHooks/useIsMobile/useIsMobile";
import useIsTablet from "../../../hooks/utilHooks/useIsMobile/useIsTablet";

interface SubNavbarProps {
    isHomePage?: boolean,
    isNbaPage?: boolean,
    isNflPage?: boolean,
    isMlbPage?: boolean,
    isNcaabbPage?: boolean,
    isNcaafbPage?: boolean,
}

export const SubNavbar = (
    {
        isHomePage = false,
        isNbaPage = false,
        isNflPage = false,
        isMlbPage = false,
        isNcaafbPage = false,
        isNcaabbPage = false
    }
        : SubNavbarProps) => {

    const navigate = useNavigate()
    const numericalDate = +get8DigitDate()
    const iAmInThailand = Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Bangkok';
    const isNbaSeason = +numericalDate.toString().substring(4,8) > 1022 ||
        +numericalDate.toString().substring(4,8) < 615
    const isNflSeason = +numericalDate.toString().substring(4,8) >= 715 ||
        +numericalDate.toString().substring(4,8) <= (iAmInThailand ? 210 : 209);
    const isNcaafbSeason = +(get8DigitDate().substring(4,8)) >= 720 || +(get8DigitDate().substring(4,8)) <= 121
    const isNcaabbSeason = +(get8DigitDate().substring(4,8)) >= 1104 || +(get8DigitDate().substring(4,8)) <= 409
    const isMlbSeason = +(get8DigitDate().substring(4,8)) >= 318 || +(get8DigitDate().substring(4,8)) <= 1030
    const isMobile = useIsMobile()
    const isTablet = useIsTablet()
    const isMobileOrTablet = isTablet || isMobile

    return (
        <Grid
            item
            container
            xs={12}
            mt={3}
            rowGap={1}
            columnGap={1}
            display="flex"
            justifyContent="center"
            flexWrap="wrap"
        >
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    mr={isMobileOrTablet ? 0 : 3}
                    sx={{ position: 'relative' }}
                >
                    <Chip
                        variant={isNbaPage && isNbaSeason ? 'filled' : 'outlined'}
                        label="NBA"
                        color="primary"
                        size="small"
                        disabled={!isNbaSeason}
                        onClick={() => navigate(`/nba`)}
                        clickable
                    />
                    <Link mt={1}
                          onClick={() => navigate(`/nba-query`)}
                    >
                        <Typography
                            variant="caption"
                            sx={{
                                '&:hover': {
                                    backgroundColor: 'lightgrey',
                                    cursor: 'pointer',
                                },
                            }}
                        >
                            NBA Query
                        </Typography>
                    </Link>
                    <Link
                        mt={1}
                        onClick={() => navigate(`/nba-trend-finder`)}
                    >
                        <Typography
                            variant="caption"
                            sx={{
                                cursor: 'pointer',
                                zIndex: 10,
                                '&:hover': {
                                    backgroundColor: 'lightgrey',
                                },
                            }}
                        >
                            NBA Trend-finder
                        </Typography>
                    </Link>
                </Box>
            {/*<Box*/}
            {/*    display="flex"*/}
            {/*    flexDirection="column"*/}
            {/*    alignItems="center"*/}
            {/*    mr={isMobileOrTablet ? 0 : 4}*/}
            {/*    sx={{ position: 'relative' }}*/}
            {/*>*/}
            {/*    <Chip*/}
            {/*        variant={isMlbPage ? 'filled' : 'outlined'}*/}
            {/*        label="MLB"*/}
            {/*        color="primary"*/}
            {/*        size="small"*/}
            {/*        onClick={() => navigate(`/mlb`)}*/}
            {/*        disabled={!isMlbSeason}*/}
            {/*        clickable*/}
            {/*    />*/}
            {/*    <Link mt={1}*/}
            {/*          onClick={() => navigate(`/mlb-query`)}*/}
            {/*    >*/}
            {/*        <Typography*/}
            {/*            variant="caption"*/}
            {/*            sx={{*/}
            {/*                '&:hover': {*/}
            {/*                    backgroundColor: 'lightgrey',*/}
            {/*                    cursor: 'pointer',*/}
            {/*                },*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            MLB Query*/}
            {/*        </Typography>*/}
            {/*    </Link>*/}
            {/*    <Link*/}
            {/*        mt={1}*/}
            {/*        onClick={() => navigate(`/mlb-trend-finder`)}*/}
            {/*    >*/}
            {/*        <Typography*/}
            {/*            variant="caption"*/}
            {/*            sx={{*/}
            {/*                '&:hover': {*/}
            {/*                    backgroundColor: 'lightgrey',*/}
            {/*                    cursor: 'pointer',*/}
            {/*                },*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            MLB Trendfinder*/}
            {/*        </Typography>*/}
            {/*    </Link>*/}
            {/*</Box>*/}
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    mr={isMobileOrTablet ? 0 : 3}
                    sx={{ position: 'relative' }}
                >
                        <Chip
                            variant={isNcaabbPage ? 'filled' : 'outlined'}
                            label="NCAA BB"
                            color="primary"
                            size="small"
                            onClick={() => navigate(`/ncaabb`)}
                            disabled={!isNcaabbSeason}
                            clickable
                        />
                        <Link mt={1}>
                            <Typography
                                variant="caption"
                                onClick={() => navigate(`/ncaabb-query`)}
                                sx={{
                                    '&:hover': {
                                        backgroundColor: 'lightgrey',
                                        cursor: 'pointer',
                                    },
                                }}
                            >
                                NCAABB Query
                            </Typography>
                        </Link>
                        <Link mt={1}
                              onClick={() => navigate(`/ncaabb-trend-finder`)}
                        >
                            <Typography
                                variant="caption"
                                sx={{
                                    '&:hover': {
                                        backgroundColor: 'lightgrey',
                                        cursor: 'pointer',
                                    },
                                }}
                            >
                                NCAABB Trend-finder
                            </Typography>
                        </Link>
                    </Box>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    mr={isMobileOrTablet ? 0 : 4}
                    sx={{ position: 'relative' }}
                >
                    <Chip
                        variant={isNflPage ? 'filled' : 'outlined'}
                        label="NFL"
                        color="primary"
                        size="small"
                        onClick={() => navigate(`/nfl`)}
                        disabled={!isNflSeason}
                        clickable
                    />
                    <Link mt={1}
                          onClick={() => navigate(`/nfl-query`)}
                    >
                        <Typography
                            variant="caption"
                            sx={{
                                '&:hover': {
                                    backgroundColor: 'lightgrey',
                                    cursor: 'pointer',
                                },
                            }}
                        >
                            NFL Query
                        </Typography>
                    </Link>
                    <Link
                        mt={1}
                        onClick={() => navigate(`/nfl-trend-finder`)}
                    >
                        <Typography
                            variant="caption"
                            sx={{
                                '&:hover': {
                                    backgroundColor: 'lightgrey',
                                    cursor: 'pointer',
                                },
                            }}
                        >
                            NFL Trendfinder
                        </Typography>
                    </Link>
                </Box>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    sx={{ position: 'relative' }}
                >
                    <Chip
                        variant={isNcaafbPage ? 'filled' : 'outlined'}
                        label="NCAA FB"
                        color="primary"
                        size="small"
                        onClick={() => navigate(`/ncaafb`)}
                        disabled={!isNcaafbSeason}
                        clickable
                    />
                    <Link mt={1}
                          onClick={() => navigate(`/ncaafb-query`)}
                    >
                        <Typography
                            variant="caption"
                            sx={{
                                '&:hover': {
                                    backgroundColor: 'lightgrey',
                                    cursor: 'pointer',
                                },
                            }}
                        >
                            NCAA FB Query
                        </Typography>
                    </Link>
                    <Link mt={1}
                          onClick={() => navigate(`/ncaafb-trend-finder`)}
                    >
                        <Typography
                            variant="caption"
                            sx={{
                                '&:hover': {
                                    backgroundColor: 'lightgrey',
                                    cursor: 'pointer',
                                },
                            }}
                        >
                            NCAA FB Trendfinder
                        </Typography>
                    </Link>
                </Box>
            <Box ml={2}>
                <Legend />
            </Box>

        </Grid>
    )
}